export default {"src":"/_next/static/media/Duplicate.02ebc917.svg","height":16,"width":16};